module.exports = __webpack_public_path__ + "img/031.d94483c9.png";